export const capitalizeWord = (value: string) => {
  if (value && value.length) {
    return value
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  } else {
    return "";
  }
};
